import { Button, Form } from "antd";
import React, { useEffect, useState } from "react";

function Payment({ data }) {
  const [creditCardError, setCreditCardError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [selectedExistingCreditCard, setSelectedExistingCreditCard] = useState(null);
  let submitKeapCardIframeTimeout = null;

  const sendMessageToIframe = () => {
    setSubmitting(true);
    if (selectedExistingCreditCard !== 'new' && selectedExistingCreditCard !== null) {
      onFinish(selectedExistingCreditCard);
      return;
    }

    const iframe = document.getElementById("paymentIframe");

    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage("submit", "*");

      submitKeapCardIframeTimeout = setTimeout(() => {
        // Assuming `btn` is a button element in your component state
        console.log("submitKeapCardIframeTimeout");
      }, 3000);
    } else {
      console.error("Credit card frame not found");
    }
  };

  const onFinish = async (creditCardId) => {
    const submitData = { ...data, creditCardId, mock: false };
    // remove unecessary data
    delete submitData.phoneNumberVerificationCode;
    delete submitData.lastPhoneNumberVerificationCode;
    delete submitData.isPhoneVerified;
    delete submitData.acceptedConditions;
    delete submitData.passwordConfirmation;
    delete submitData.sessionKey;
    delete submitData.existingCreditCards;
    delete submitData.isAgencyAccount;

    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(submitData) // stringify will strip undefined values
    };
    try {
      const response = await fetch(process.env.REACT_APP_REGISTRATION_ENDPOINT ?? "", requestOptions);
      if (response.status === 200) {
        const data = await response.json();
        window.onbeforeunload = null;
        window.location.href = data.redirectUrl;
        return;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const onFinishFailed = () => {
    console.log("we're gonna do some calls here");
  };

  const submitSignUpForm = ({ data }) => {
    if (!data || data.hello || data.creditCardId === undefined) {
      setSubmitting(false);
      return;
    }

    console.log(data);

    clearTimeout(submitKeapCardIframeTimeout);
    const creditCardId = data.creditCardId;
    if (isNaN(creditCardId) || Number(creditCardId) <= 0) {
      setCreditCardError(true);
      setSubmitting(false);
      return;
    }

    onFinish(creditCardId);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      submitSignUpForm(event);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        flexDirection: "column"
      }}>

      {creditCardError && (
        <div
          style={{
            backgroundColor: "#ff6666",
            color: "white",
            padding: "10px",
            textAlign: "center",
            width: "70%",
            fontWeight: "bold",
            marginBottom: "10px",
            borderRadius: "5px"
          }}
        >
          ⚠️ We ran into an issue validating your credit card details. Please ensure everything is correct before proceeding.
        </div>
      )}

      <Form
        name="basic"
        layout="vertical"
        initialValue={{
          remember: true,
        }}
        onFinish={sendMessageToIframe}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="w-[100%]"
      >
        {/* single select drop down populated with data.existingCreditCards */}
        {data.existingCreditCards.length > 0 && (
          <Form.Item
            label="Select a credit card"
            name="creditCardId"
            validateTrigger="onBlur"
            rules={[{ required: true, message: "Please select a credit card" }]}
          >
            <select
              style={{ width: "100%", height: "40px", marginBottom: "20px" }}
              onChange={(e) => setSelectedExistingCreditCard(e.target.value)}
            >
              <option value="new">Create New Card</option>
              {data.existingCreditCards.map((card) => (
                <option key={card.id} value={card.id}>
                  {card.name}
                </option>
              ))}
            </select>
          </Form.Item>
        )}

        {(!data.existingCreditCards.length || (data.existingCreditCards.length && selectedExistingCreditCard === 'new')) && (
          <iframe
            id="paymentIframe"
            src={`https://payments.keap.page/${data.sessionKey}`}
            width="100%"
            height="300"
            style={{ border: "1px solid #ccc", marginBottom: "20px" }} // Adjust styling as needed
            title="Embedded Content"
          ></iframe>
        )}

        <div className="flex justify-between">
          <Form.Item>
            <Button type="primary" onClick={() => data.changeStep("plan")}>
              Go Back
            </Button>
          </Form.Item>
          <Form.Item >
            <Button type="primary" htmlType="submit" disabled={submitting} loading={submitting} className="flex justify-end">
              {submitting ? "Submitting..." : "Submit"}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
}

export default Payment;
